<div class="modal-header">
  <h4 class="modal-title">
    {{ 'Place announcement' | translate }}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <!-- Visibility Warning -->
  <div class="alert alert-info mb-4" role="alert">
    <div class="d-flex align-items-start">
      <i class="fas fa-info-circle mt-1 mr-2"></i>
      <div>
        {{ 'By placing this request, your profile will become visible to all companies registered on our platform. This allows them to view your information and potentially reach out to you with relevant opportunities.' | translate }}
      </div>
    </div>
  </div>
  <form [formGroup]="announcementForm" (ngSubmit)="onSubmit()">
    <!-- Type Selection -->
    <div class="form-group">
      <label for="announcementType">
        {{ 'Looking for' | translate }}
      </label>
      <select id="announcementType" class="form-control" formControlName="type" [class.is-invalid]="isFieldInvalid('type')">
        <option *ngFor="let option of lookingForOptions" [value]="option.value">
          {{ option.name | translate }}
        </option>
      </select>
      <div class="invalid-feedback" *ngIf="isFieldInvalid('type')">
        {{ 'Please fill in what you are looking for' | translate }}
      </div>
    </div>

    <!-- Motivation -->
    <div class="form-group">
      <label for="announcementMotivation">
        {{ 'Motivation' | translate }}
      </label>
      <textarea id="announcementMotivation" class="form-control" formControlName="motivation" [class.is-invalid]="isFieldInvalid('motivation')" rows="4" [placeholder]="'Describe briefly what you are looking for and why...' | translate">
      </textarea>
      <div class="invalid-feedback" *ngIf="isFieldInvalid('motivation')">
        {{ 'Fill in a clear motivation for this announcement' | translate }}
      </div>
      <small class="form-text text-muted">
        {{ 'Minimum characters' | translate: {count: motivationMinLength} }}
      </small>
    </div>

    <!-- Start Date -->
    <div class="form-group">
      <label for="announcementStartDate">
        {{ 'Start date' | translate }}
      </label>
      <input id="announcementStartDate" type="date" class="form-control" formControlName="startDate" [class.is-invalid]="isFieldInvalid('startDate')" [min]="minDate">
      <div class="invalid-feedback" *ngIf="isFieldInvalid('startDate')">
        {{ 'Please fill in start date' | translate }}
      </div>
    </div>

    <!-- End Date (only for internships) -->
    <div class="form-group" *ngIf="selectedType === ProfileLookingFor.Stage">
      <label for="announcementEndDate">
        {{ 'End date' | translate }}
      </label>
      <input id="announcementEndDate" type="date" class="form-control" formControlName="endDate" [class.is-invalid]="isFieldInvalid('endDate')" [min]="startDateValue">
      <div class="invalid-feedback" *ngIf="isFieldInvalid('endDate')">
        {{ 'End date is required for internships' | translate }}
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary mr-2" (click)="activeModal.dismiss()">
    {{ 'Cancel' | translate }}
  </button>
  <button type="button" class="btn btn-primary" [disabled]="announcementForm.invalid || isSubmitting" (click)="onSubmit()">
    <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm mr-2"></span>
    {{ 'Place announcement' | translate }}
  </button>
</div>
